import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';

// TikTok icon component
const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

export const Footer = () => {
  return (
    <footer className="bg-[#0A2320] text-white font-['Poppins']">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          {/* Logo and description */}
          <div className="md:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_majordhome/artifacts/nr0l6515_LOGO%20BLANC.png" 
              alt="The MajordHome Conciergerie" 
              className="h-28 mb-5"
            />
            <p className="text-white/70 text-sm leading-relaxed">
              Services à la personne de qualité avec 50% de crédit d'impôt immédiat.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-5 text-white">Nos services</h3>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><Link to="/service/menage" className="hover:text-[#D4AF37] transition-colors">Ménage</Link></li>
              <li><Link to="/service/jardinage" className="hover:text-[#D4AF37] transition-colors">Jardinage</Link></li>
              <li><Link to="/service/bricolage" className="hover:text-[#D4AF37] transition-colors">Bricolage</Link></li>
              <li><Link to="/service/demenagement" className="hover:text-[#D4AF37] transition-colors">Aide au déménagement</Link></li>
              <li><Link to="/service/administratif" className="hover:text-[#D4AF37] transition-colors">Aide administrative</Link></li>
              <li><Link to="/service/vehicule" className="hover:text-[#D4AF37] transition-colors">Nettoyage de véhicule</Link></li>
              <li><Link to="/service/airbnb" className="hover:text-[#D4AF37] transition-colors">Gestion Airbnb</Link></li>
            </ul>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-bold text-lg mb-5 text-white">Informations</h3>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><Link to="/tmc" onClick={() => window.scrollTo(0, 0)} className="hover:text-[#D4AF37] transition-colors">Qui sommes-nous</Link></li>
              <li><Link to="/tmc#engagements" onClick={() => window.scrollTo(0, 0)} className="hover:text-[#D4AF37] transition-colors">Nos engagements</Link></li>
              <li><Link to="/credit-impot" onClick={() => window.scrollTo(0, 0)} className="hover:text-[#D4AF37] transition-colors">Crédit d'impôt</Link></li>
              <li><Link to="/#temoignages" onClick={() => { window.scrollTo(0, 0); setTimeout(() => document.getElementById('temoignages')?.scrollIntoView({ behavior: 'smooth' }), 100); }} className="hover:text-[#D4AF37] transition-colors">Témoignages</Link></li>
              <li><Link to="/candidature" onClick={() => window.scrollTo(0, 0)} className="hover:text-[#D4AF37] transition-colors">Recrutement</Link></li>
            </ul>
          </div>

          {/* Contact - SANS le numéro 06 + mention horaires */}
          <div>
            <h3 className="font-bold text-lg mb-5 text-white">Contact</h3>
            <ul className="space-y-4 text-white/70 text-sm">
              <li>
                <a href="tel:0981543842" className="flex items-start gap-3 hover:text-[#D4AF37] transition-colors">
                  <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
                    <Phone className="h-4 w-4 sm:h-5 sm:w-5" />
                  </div>
                  <div>
                    <span className="font-medium block">09 81 54 38 42</span>
                    <span className="text-white/50 text-xs">Disponible aux horaires d'ouverture</span>
                  </div>
                </a>
              </li>
              <li>
                <a href="mailto:tmc60110@gmail.com" className="flex items-center gap-3 hover:text-[#D4AF37] transition-colors">
                  <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
                    <Mail className="h-4 w-4 sm:h-5 sm:w-5" />
                  </div>
                  <span>tmc60110@gmail.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
                  <MapPin className="h-4 w-4 sm:h-5 sm:w-5" />
                </div>
                <span>
                  60110 Méru - Oise<br />
                  <span className="text-white/50 text-xs">Rayon : 50 km</span>
                </span>
              </li>
            </ul>

            {/* Social icons */}
            <div className="flex gap-3 mt-6">
              <a 
                href="https://www.facebook.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-white/10 flex items-center justify-center text-white/70 hover:bg-[#D4AF37] hover:text-white transition-all"
                aria-label="Facebook"
              >
                <Facebook className="h-4 w-4 sm:h-5 sm:w-5" />
              </a>
              <a 
                href="https://www.instagram.com/tm_conciergerie?igsh=a2VnMnViYXBpa3Rn" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-white/10 flex items-center justify-center text-white/70 hover:bg-[#D4AF37] hover:text-white transition-all"
                aria-label="Instagram"
              >
                <Instagram className="h-4 w-4 sm:h-5 sm:w-5" />
              </a>
              <a 
                href="https://www.tiktok.com/@themajordhome?_r=1&_t=ZN-92x2rdKe9Ac" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-white/10 flex items-center justify-center text-white/70 hover:bg-[#D4AF37] hover:text-white transition-all"
                aria-label="TikTok"
              >
                <TikTokIcon className="h-4 w-4 sm:h-5 sm:w-5" />
              </a>
              <a 
                href="https://www.linkedin.com/in/the-majordhome-conciergerie-341186367" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-white/10 flex items-center justify-center text-white/70 hover:bg-[#D4AF37] hover:text-white transition-all"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-4 w-4 sm:h-5 sm:w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-white/50">
            <p>© 2025 The MajordHome Conciergerie. Tous droits réservés.</p>
            <div className="flex gap-6 mt-4 md:mt-0">
              <a href="#" className="hover:text-[#D4AF37] transition-colors">Mentions légales</a>
              <a href="#" className="hover:text-[#D4AF37] transition-colors">Confidentialité</a>
              <a href="#" className="hover:text-[#D4AF37] transition-colors">CGV</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
